export const VALID_BANK_CHECK_DIGITS = ["42", "16", "10", "22", "96", "17", "12", "83", "00", "51", "77", "75"]

export const BANK_ACCOUNT_NUMBER_REGEX_PATTERN = `^EE(\\d{2})(${VALID_BANK_CHECK_DIGITS.join("|")})(\\d{11,})$`;
export const BANK_ACCOUNT_NUMBER_REGEX_EXPRESSION = new RegExp(BANK_ACCOUNT_NUMBER_REGEX_PATTERN);

export const EMAIL_REGEX_EXPRESSION = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[\w-]{2,4}$/;

const INVALID_EMAIL_DOMAINS = ['con', 'comm', 'COM', 'vom', 'com>', 'comm', 'gom', 'come', 'xom'];
export const INVALID_EMAIL_DOMAIN_REGEX_EXPRESSION = new RegExp(`.*@(.*)\\.(${INVALID_EMAIL_DOMAINS.join('|')})$`);